// Auto-generated by the generator
// Don't manually edit this file

// @flow

import type {Action} from '../../types'
import type {HospitalState} from '../types'

import {setLoadingReducer} from './setLoading'
import {setCitiesReducer} from './setCities'
import {setDistrictsReducer} from './setDistricts'
import {setSelectedCityReducer} from './setSelectedCity'
import {initialState} from './initialState'

export const hospitalReducer = (state: HospitalState = initialState, action: Action<any>): HospitalState => {
  switch (action.type) {
    case 'hospital/SET_LOADING':
      return setLoadingReducer(state, action)
    case 'hospital/SET_CITIES':
      return setCitiesReducer(state, action)
    case 'hospital/SET_DISTRICTS':
      return setDistrictsReducer(state, action)
    case 'hospital/SET_SELECTED_CITY':
      return setSelectedCityReducer(state, action)
    default:
      return state
  }
}
